import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { useAuth } from "@/features/auth/store";
import { ArrivalListPage } from "@/features/arrival/components/list/arrival-list-page";

const search = z.object({
  tab: z.string().default("draft"),
  q: z.string().optional(),
  from: z.string().optional(),
  to: z.string().optional(),
  page: z.number().int().min(1).default(1),
});

/** Every arrival, whatever its form — the ⌘K target and the drill-down from a form's own list. */
export const Route = createFileRoute("/_app/arrivals/")({
  validateSearch: search,
  beforeLoad: () => {
    if (!useAuth.getState().can("document.view")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const s = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <ArrivalListPage
      title="All arrivals"
      description="Every arrival transaction at this plant."
      search={s}
      onSearch={(next) =>
        void navigate({ search: (prev) => ({ ...prev, ...next }) })
      }
    />
  );
}
